<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemMergeMode} from "@/modules/redactor/models/item/merge/ItemMergeMode";


export default {
  name: "r-item-merge-mode",
  props: {
    model: VueTypes.instanceOf(ItemMergeMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemMergeMode.getValues();
    }
  }
}
</script>